import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import MultiSelect from "components/common/MultiSelect";
import {
  GetAllPoyer,
  GetPayerInsurance,
} from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { handlePrepareClaimFilter } from "../config/claimSlice";
import { GetInsuranceList } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { GetAllClaimType } from "../config/cliamApi";
import classNames from "classnames";

const PrepareClaimFilter = ({
  watch,
  setValue,
  control,
  errors,
  isSubmitted,
}) => {
  const dispatch = useDispatch();
  const { poyerList, payerInsurance } = useSelector(
    (state) => state.eligibilityCheckList
  );
  const { insuranceList } = useSelector((state) => state.eligibilityCheck);
  const { prepareClaimFilters, cliamTypeList } = useSelector(
    (state) => state.claim
  );

  const { userData } = useSelector((state) => state.auth);
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch",
  );

  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const payer = watch("payer");
  useEffect(() => {
    if (insuranceList?.length === 0) {
      dispatch(GetInsuranceList());
    }
    if (cliamTypeList?.length === 0) {
      dispatch(GetAllClaimType());
    }
  }, [insuranceList, cliamTypeList]);

  const handleBranch = (selected) => {
    if (!selected) {
      setValue("branch", null);
      dispatch(
        handlePrepareClaimFilter({
          check: "branch",
          value: null,
        })
      );
      return;
    }

    const value = {
      branch_name: selected.label,
      branch_id: selected.value,
    };
    setValue("branch", value);
    dispatch(handlePrepareClaimFilter({ check: "branch", value }));
  };
  const handleInsurance = (selected) => {
    if (!selected) {
      setValue("insurance", null);
      dispatch(
        handlePrepareClaimFilter({
          check: "insurance",
          value: null,
        })
      );
      return;
    }

    const value = {
      payer_name: selected?.original?.payer_name,
      insurance_company_id: selected?.original.insurance_company_id,
      insurance_direct: selected?.original.insurance_direct,
      insurance_shname: selected?.original.insurance_shname,
    };

    setValue("insurance", value);
    dispatch(handlePrepareClaimFilter({ check: "insurance", value }));
  };
  const handleStartDate = (selected) => {
    setValue("start_date", selected);

    dispatch(
      handlePrepareClaimFilter({
        check: "start_date",
        value: selected,
      })
    );
  };
  const handleEndDate = (selected) => {
    setValue("end_date", selected);

    dispatch(
      handlePrepareClaimFilter({
        check: "end_date",
        value: selected,
      })
    );
  };

  const handleClaimType = (selected) => {
    if (!selected) {
      setValue("claim_type", null);
      dispatch(
        handlePrepareClaimFilter({
          check: "claim_type",
          value: null,
        })
      );
      return;
    }

    const value = {
      claim_types_name: selected.label,
      claim_types_id: selected.value,
    };
    setValue("claim_type", value);
    dispatch(handlePrepareClaimFilter({ check: "claim_type", value }));
  };
  useEffect(() => {
    if (poyerList?.length === 0) {
      dispatch(GetAllPoyer());
    }
  }, []);
  useEffect(() => {
    setValue("insurance", prepareClaimFilters?.insurance);
    if (prepareClaimFilters?.branch) {
      setValue("branch", prepareClaimFilters?.branch);
    } else if (selectedBranch) {
      const defaultBranch = {
        branch_name: selectedBranch.label || selectedBranch.branch_name,
        branch_id: selectedBranch.value || selectedBranch.branch_id,
      };
      setValue("branch", defaultBranch);
      dispatch(handlePrepareClaimFilter({ check: "branch", value: defaultBranch }));
    } else {
      setValue("branch", null);
    }
    setValue("claim_type", prepareClaimFilters?.claim_type);
    setValue("start_date", prepareClaimFilters?.start_date);
    setValue("end_date", prepareClaimFilters?.end_date);
  }, []);

  return (
    <Row>
      {(Number(branchSetting?.list) === 1 && userData?.employee?.syspri_id === 1) || userData?.employee?.syspri_id === 2 ? (
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Branch</label>
          <Controller
            name="branch"
            control={control}
            rules={{ required: "Branch is required" }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                disabled={userData?.employee?.syspri_id === 2}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={allBranches?.map((item) => ({
                  value: item.branch_id,
                  label: item.branch_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                        value: field.value.branch_id,
                        label: field.value.branch_name,
                      }
                    : null
                }
                onChange={(selected) => handleBranch(selected)}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
      ) : null}
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">Insurance</label>
        <Controller
          name="insurance"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              options={insuranceList?.map((payer) => ({
                value: payer.insurance_company_id,
                code: payer.insurance_direct,
                label:
                  payer.insurance_direct === 1
                    ? payer.payer_name
                    : `${payer.payer_name} - ${payer.insurance_shname}`,
                original: payer, // Keep full object if needed
              }))}
              isClearable={true}
              placeholder="Choose..."
              onChange={(selected) => handleInsurance(selected)}
              className={classNames({
                "is-invalid":
                  errors.insurance || (isSubmitted && !watch("insurance")),
              })}
              value={
                field.value
                  ? {
                      value: field.value.payer_id,
                      label:
                        field.value.insurance_direct === 1
                          ? field.value.payer_name
                          : `${field.value.payer_name} - ${field.value.insurance_shname}`,
                    }
                  : null
              }
            />
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Label>Claim Type</Form.Label>
        <Controller
          name="claim_type"
          control={control}
          render={({ field }) => (
            <>
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                size="sm"
                options={cliamTypeList?.map((item) => ({
                  value: item?.claim_types_id,
                  label: item?.claim_types_name,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                        value: field.value.claim_types_id,
                        label: field.value.claim_types_name,
                      }
                    : null
                }
                onChange={(selected) => handleClaimType(selected)}
                placeholder="Choose..."
              />
            </>
          )}
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootDatePicker
          name="start_date"
          label="Start date"
          size="sm"
          className={classNames({
            "is-invalid":
              errors.start_date || (isSubmitted && !watch("start_date")),
          })}
          control={control}
          onChange={(date) => handleStartDate(date)}
          isRequired={true}
          errors={errors}
          rules={{ required: true }}
          placeholder="dd/mm/yyyy"
        />
      </Col>
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootDatePicker
          name="end_date"
          label="End date"
          size="sm"
          className={classNames({
            "is-invalid":
              errors.end_date || (isSubmitted && !watch("end_date")),
          })}
          isRequired={true}
          errors={errors}
          rules={{ required: true }}
          control={control}
          onChange={(date) => handleEndDate(date)}
          placeholder="dd/mm/yyyy"
        />
      </Col>
    </Row>
  );
};

export default PrepareClaimFilter;
